import { render } from "./ErrorHandling.vue?vue&type=template&id=d6498746"
import script from "./ErrorHandling.vue?vue&type=script&lang=js"
export * from "./ErrorHandling.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/biz-billing-frontend/biz-billing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__